import { inject } from 'inversify';

import { STATUS } from '@/constants';
import { UserController } from '@/controllers/UserController';
import { service } from '@/decorators/service';
import { SignalrListener } from '@/decorators/signalr';
import { Logger } from '@/services/Logger';
import { Signalr } from '@/services/signalr/Signalr';
import { FeaturesStore } from '@/stores/FeaturesStore';
import { IListItem } from '~/api/IListItem';

@SignalrListener
@service(FeaturesManager)
export class FeaturesManager {
  @inject(Logger) protected logger: Logger;
  @inject(Signalr) protected signalr: Signalr;
  @inject(UserController) protected userController: UserController;
  @inject(FeaturesStore) protected featuresStore: FeaturesStore;

  find(id: string) {
    return this.featuresStore.find(id);
  }

  findByFeature(label: string) {
    return this.all.find((feature) => feature.value === label);
  }

  hasFeatureToggle(featureToggle: string): boolean {
    const feature = this.findByFeature(featureToggle);
    return !!(feature ?? false);
  }

  get all() {
    return this.featuresStore.all().filter((feature) => feature.status !== STATUS.DISABLED);
  }

  reset() {
    this.featuresStore.set([]);
  }

  updateFeatures(features: IListItem[]) {
    this.featuresStore.update(...features);
  }
}
